<template>
  <div
    class="log-details"
    :key="`log-details-${id}`"
  >
    <template v-if="isLoaded">
      <template v-if="isFailed">
        <error-message
          :message="errorMessage | globalize"
        />
      </template>
      <template v-else>
        <div class="log-details__account app__block">
          <h3 class="log-details__header">
            {{ "log-details.header-log-details" | globalize }}
          </h3>
          <ul class="app-key-value__list">
            <li class="app-key-value__row">
              <span class="app-key-value__key">
                {{ 'log-details.title-log-id' | globalize }}
              </span>
              <span
                class="app-key-value__value"
                :title="log.id"
              >
                {{ log.id || '-' }}
              </span>
            </li>

            <li class="app-key-value__row">
              <span class="app-key-value__key">
                {{ 'log-details.title-user-id' | globalize }}
              </span>
              <span
                class="app-key-value__value"
                :title="log.userId"
              >
                {{ log.userId || '-' }}
              </span>
            </li>

            <li class="app-key-value__row">
              <span class="app-key-value__key">
                {{ 'log-details.title-log-type' | globalize }}
              </span>
              <span
                class="app-key-value__value"
                :title="log.logNotesType"
              >
                {{ log.logNotesType || '-' }}
              </span>
            </li>

            <li class="app-key-value__row">
              <span class="app-key-value__key">
                {{ 'log-details.title-log-time' | globalize }}
              </span>
              <span
                class="app-key-value__value"
                :title="log.logTime | formatDateDMYT"
              >
                {{ log.logTime | formatDateDMYT }}
              </span>
            </li>
          </ul>
        </div>

        <div
          v-if="log.isNotEmptyLogNotes"
          class="log-details__details app__block "
        >
          <h3 class="log-details__header">
            {{ "log-details.header-log-notes" | globalize }}
          </h3>
          <details-reader :details="log.logNotes" />
        </div>
      </template>
    </template>
    <template v-else>
      <loader
        class="log-details__loader"
        message-id="loading"
        position-center
      />
    </template>
  </div>
</template>

<script>

import DetailsReader from '@/vue/common/DetailsReader/DetailsReader'
import Loader from '@/vue/common/Loader'
import ErrorMessage from '@/vue/common/ErrorMessage'

import { errors } from '@/js/errors'

import { api } from '@/api'
import { LogRecord } from '@/js/records/entities/log.record'
import { ErrorHandler } from '@/js/helpers/error-handler'

export default {
  name: 'log-details',
  components: {
    DetailsReader,
    Loader,
    ErrorMessage,
  },
  props: {
    id: { type: String, required: true },
  },
  data () {
    return {
      isLoaded: false,
      isFailed: false,
      errorMessage: 'log-details.default-error-message',
    }
  },

  async created () {
    await this.getLogById()
  },

  methods: {
    async getLogById () {
      this.isLoaded = false
      try {
        let { data } = await api.getWithSignature(`/logs/${this.id}`)
        this.log = new LogRecord(data)
      } catch (error) {
        this.isFailed = true
        switch (error.constructor) {
          case errors.NotFoundError:
            this.errorMessage = 'log-details.not-found-error-message'
            ErrorHandler.processWithoutFeedback(error)
            break
          default:
            this.errorMessage = 'log-details.default-error-message'
            ErrorHandler.processWithoutFeedback(error)
        }
      }
      this.isLoaded = true
    },
  },
}
</script>

<style lang="scss" scoped>
.log-details__header {
  margin-bottom: 2rem;
}

.log-details__details {
  margin-top: 4rem;
}
</style>
